import _ from 'lodash';
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';

export default class Tooltip
extends Component {
	render () {
		const { tooltipAt = 'top', tooltipText, tooltipContent, fieldKey } = this.props;

		if (_.isString(tooltipText) !== true) {

			return null;
		}

		return (
			<span>
				<a data-tip data-for={ `${fieldKey}-tooltip` }>{ `(${tooltipText})` }</a>

				<ReactTooltip id={ `${fieldKey}-tooltip` } className="hfm-tooltip" effect="solid" place={ tooltipAt }>
					<div className="padding-1">
						{ tooltipContent }
					</div>
				</ReactTooltip>
			</span>
		);
	}
};
